/* eslint-disable no-console */
import React from 'react';
import {
  Cell,
  Label,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer
  // Tooltip
} from 'recharts';

import {handleFalsyValues} from '../../../constants/Common';
import {collageOfColors} from '../../../pages/netZero/constants/commonConstants';
import {formatIndian} from '../../../utils/formatIndian';
import {PieChartMultiStyle} from '../RadialChart/constants/common';

import PieScopeCustomizedLegend from './utils/PieScopeCustomLegend';
import RenderCustomizedLabelScope from './utils/RenderCustomizedLabelScope';

const PieChartMulti: React.FC<{
  data: any;
  showLegend?: boolean;
  showLabel?: boolean;
  center?: boolean;
  lessRound?: boolean;
  inside?: boolean;
  mainData?: any | undefined;
  showCenterLabel?: boolean;
  customLabel?: string;
  addExtra?: boolean;
}> = ({
  data,
  showLegend = false,
  center = false,
  showLabel = false,
  inside = false,
  lessRound = false,
  mainData = undefined,
  showCenterLabel = false,
  customLabel = '',
  addExtra = false
}) => {
  if (addExtra) {
    data?.unshift({value: mainData?.value, fill: '#E4E6EE'});
  }
  if (
    data?.every((item: any) => {
      return item?.value === 0 || typeof item?.value !== 'number';
    })
  ) {
    data = [{value: 100, fill: '#E0EFFD'}];
  }

  data = handleFalsyValues(data);

  const mainTitle = mainData?.label?.split(' ') ?? [''];
  const lastWord = mainTitle[mainTitle?.length - 1];

  const CustomCenterLabel = ({props}: any) => {
    const {cx, cy} = props.viewBox;

    return (
      <>
        {mainData?.description && (
          <text
            x={cx}
            y={cy - 15}
            fill="#677489"
            className="recharts-text recharts-label"
            textAnchor="middle"
            dominantBaseline="central"
            style={{
              font: 'normal normal 600 12px/15px Montserrat',
              marginBottom: '1rem'
            }}
          >
            {customLabel !== '' ? customLabel : `Total ${lastWord}`}
          </text>
        )}

        <text
          x={cx}
          y={cy + 10}
          fill="#677489"
          className="recharts-text recharts-label"
          textAnchor="middle"
          dominantBaseline="central"
        >
          <tspan
            alignmentBaseline="middle"
            fontSize="26"
            style={{
              font: 'normal normal 600 24px/29px Montserrat'
            }}
          >
            {formatIndian(mainData?.value)}
            {` ${mainData?.unit}`}
          </tspan>
          {/* <tspan
            baselineShift="sub"
            style={{
              font: 'normal normal 600 14px / 18px Montserrat'
            }}
          >
            {` ${mainData?.unit}`}
          </tspan> */}
        </text>
      </>
    );
  };

  return (
    <ResponsiveContainer
      width="100%"
      className="pieChartScope"
      style={{
        margin: '0 auto',
        flex: 1
      }}
    >
      <PieChart margin={{top: 0, left: 0, right: 0, bottom: 0}}>
        <Pie
          data={data}
          cx={center ? '50%' : '30%'}
          outerRadius={center ? '80%' : '50%'}
          innerRadius={center ? '60%' : '40%'}
          paddingAngle={inside ? -20 : 0}
          dataKey="value"
          label={
            showLabel
              ? (props) => <RenderCustomizedLabelScope {...props} />
              : undefined
          }
          nameKey="name"
          startAngle={-270}
          endAngle={90}
          cornerRadius={lessRound ? 10 : 40}
          labelLine={false}
          minAngle={inside ? 50 : 5}
          blendStroke={inside}
          strokeWidth={0}
        >
          {showCenterLabel && (
            <Label
              position="center"
              content={(props) => (
                <CustomCenterLabel props={props} data={mainData} />
              )}
            />
          )}
          {data.map((entry: any, index: number) => {
            return (
              <Cell
                style={{outline: 'none'}}
                key={`cell-${index}`}
                fill={entry.fill ?? collageOfColors[index]}
              />
            );
          })}
        </Pie>
        {showLegend && (
          <Legend
            iconSize={7}
            layout="vertical"
            verticalAlign="middle"
            iconType="circle"
            wrapperStyle={PieChartMultiStyle}
            content={<PieScopeCustomizedLegend data={data} />}
          />
        )}
      </PieChart>
    </ResponsiveContainer>
  );
};

export default PieChartMulti;
